import { getQueryString } from '@/helpers/urlParse';

const withPreviewLayout = (tour) => {
  const preview = getQueryString('preview');

  return preview ? { ...tour, settings: { ...tour.settings, layout: preview } } : tour;
};

export const mapResponseFromTourByDomain = (responseData) => ({
  tourData: withPreviewLayout(responseData.data.tourJson),
  branded: responseData.data.branded
});

export const mapResponseFromTourById = (responseData) => ({
  tourData: withPreviewLayout(responseData.data.tour),
  branded: Boolean(+getQueryString('branded'))
});
